import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from '../../axiosConfig';
import { useNavigate, useLocation } from 'react-router-dom';
import '../../styles/NewAuth.css';

const ResetPassword = () => {
    const { t } = useTranslation('auth');
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');
        setLoading(true);

        if (password !== confirmPassword) {
            setError(t('register.errors.passwordsMismatch'));
            setLoading(false);
            return;
        }

        try {
            await axios.post('/api/v1/auth/reset-password', { token, newPassword: password });
            setMessage(t('resetPassword.successMessage'));
            setTimeout(() => navigate('/'), 2000);
        } catch (err) {
            setError(t('resetPassword.error'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-box">
                <h1>{t('resetPassword.title')}</h1>
                <p>{t('resetPassword.subtitle')}</p>
                <form className="auth-form" onSubmit={handleSubmit}>
                    <input
                        type="password"
                        name="password"
                        placeholder={t('resetPassword.newPasswordPlaceholder')}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                    <input
                        type="password"
                        name="confirmPassword"
                        placeholder={t('resetPassword.confirmPasswordPlaceholder')}
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                    />
                    {message && <p className="success-message">{message}</p>}
                    {error && <p className="error">{error}</p>}
                    <button type="submit" disabled={loading}>
                        {loading ? t('resetPassword.saving') : t('resetPassword.resetButton')}
                    </button>
                    <button type="button" className="back-btn" onClick={() => navigate('/')}>
                        {t('forgotPassword.backToLogin')}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ResetPassword;
